import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { axios } from 'api'

import { Collapse } from 'ui/bend'

const Store = React.createContext(null)
export const useActiveMembershipContext = () => useContext(Store)

const ActiveMembership = ({ handleError, children }) => {
  const [membershipInfo, setMembershipInfo] = useState(null)
  const [refresh, setRefresh] = useState(true)
  const [plan, setPlan] = useState(null)
  const [paymentMethods, setPaymentMethods] = useState(null)
  const [paymentMethodError, setPaymentMethodError] = useState(null)

  const refreshMembershipInfo = () => {
    setRefresh(true)
  }

  useEffect(() => {
    const fetchMembership = async () => {
      const [membershipRes, planRes, currentPayment] = await Promise.allSettled(
        [
          axios.get('/users/me/membership'),
          axios.get('/users/me/membership/stripe'),
          axios.get('/payment_methods/current')
        ]
      )

      if (membershipRes.status === 'fulfilled') {
        setMembershipInfo(membershipRes.value.data)

        if (
          membershipRes.value.data.subscriptionSource === 'stripe' &&
          planRes.status === 'fulfilled'
        ) {
          if (planRes.value.data.plan) {
            setPlan(planRes.value.data.plan)
          }
        }

        if (currentPayment.status === 'fulfilled') {
          setPaymentMethods(currentPayment.value.data)
        } else {
          setPaymentMethodError(currentPayment.reason.response.status)
        }
      } else {
        handleError(membershipRes.reason.response.message)
      }
    }

    // try {
    //   const res = await axios.get('users/me/membership')

    //   if (res.status === 200) {
    //     setMembershipInfo(res.data)

    //     // get stripe plans if applicable. Will change plan data on refreshMembershipInfo()
    //     if (res.data.subscriptionSource === 'stripe') {
    //       const planRes = await axios.get('/users/me/membership/stripe')
    //       if (planRes && planRes.data.plan) {
    //         setPlan(planRes.data.plan)
    //       }
    //     }
    //   }
    // } catch (error) {
    //   handleError(error)
    // }

    // We trigger fetchMembership() on refresh so we can manually trigger refreshes after users change their state in the children components.
    if (refresh) {
      fetchMembership()
      setRefresh(false)
    }
  }, [refresh, setRefresh, setMembershipInfo, setPlan, handleError])

  ///////////////////////////////////////////////////////////

  return (
    <Store.Provider
      value={{
        membershipInfo,
        plan,
        refreshMembershipInfo,
        handleError,
        paymentMethods,
        paymentMethodError
      }}
    >
      <Collapse isOpened={Boolean(membershipInfo)}>
        {membershipInfo && children}
      </Collapse>
    </Store.Provider>
  )
}

ActiveMembership.propTypes = {
  handleError: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
}

export default ActiveMembership
